export default __webpack_public_path__ + "static/media/txt_entrance_11.58a4d840.svg";